"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_AXEPTA_PAYMENT_STATUS = void 0;
const client_1 = require("@apollo/client");
exports.GET_AXEPTA_PAYMENT_STATUS = client_1.gql `
  query getAxeptaPaymentStatus($idRefill: ID!) {
    axeptaV2Status(idRefill: $idRefill) {
      success
      transactionSuccess
      refillSuccess
      date
      amount {
        amount
        currency
      }
      errorGroup
      userMessage
      errorAction
    }
  }
`;
